<script>
import BuyerInput from './BuyerInput';

export default {
  components: {
    BuyerInput,
  },
  props: {
    value: String,
  },
};
</script>

<template lang='pug'>
.w-full.header-bottom__search
  buyer-input(
    placeholder='Search',
    type='search',
    :value='value',
    @input='$emit("search-input", $event)',
    @search='$emit("perform-search", $event)',
  )
</template>

<style>
@import '~import/index';
</style>